module.exports = __webpack_public_path__ + "img/5.348e16b7.png";